import React from 'react';
import { cn } from '@/lib/utils';
import { ThreadButton, ActionButtons } from './ActionButtons';
import SendButton from './SendButton';
import { useIsMobile } from '@/hooks/layout/use-mobile';

interface InputToolbarProps {
  isFocused: boolean;
  hasPendingMessage: boolean;
  isLoading: boolean;
  disabled: boolean;
  message: string;
  onClose?: () => void;
}

export const InputToolbar: React.FC<InputToolbarProps> = ({
  isFocused,
  hasPendingMessage,
  isLoading,
  disabled,
  message,
  onClose
}) => {
  const { isMobile } = useIsMobile();
  return (
    <div
      className={cn(
        "relative flex items-center bg-slate-100/50 dark:bg-slate-800/50 backdrop-blur-lg rounded-xl",
        "border border-slate-200/50 dark:border-slate-700/50",
        "transition-shadow duration-300 h-11",
        "shadow-sm px-3",
        isFocused ? "ring-1 ring-blue-200/40 dark:ring-blue-800/20" : "",
        hasPendingMessage && "animate-pulse duration-300"
      )}
      data-testid="copilot-input-toolbar"
    >
      {isMobile && (
        <div className="flex items-center text-slate-400">
          <ThreadButton onClose={onClose} />
        </div>
      )}
      
      <div className="flex-1"></div>
      
      <div className="flex items-center gap-2">
        <ActionButtons />
        
        <SendButton 
          isLoading={isLoading}
          disabled={disabled}
          messageText={message}
        />
      </div>
    </div>
  );
};

export default InputToolbar;
